import { NgModule } from '@angular/core';
import { AuthenticationRoutingModule } from './authentication-routing.module';
import { LoginComponent } from './login/login.component';
import { PasswordResetConfirmComponent } from './password-reset-confirm/password-reset-confirm.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { SharedModule } from '../../shared/shared.module';
import { AuthenticationComponent } from './authentication.component';

@NgModule({
  declarations: [
    LoginComponent,
    AuthenticationComponent,
    PasswordResetConfirmComponent,
    PasswordResetComponent,
  ],
  imports: [
    SharedModule,
    AuthenticationRoutingModule,
  ]
})
export class AuthenticationModule { }
